import styled from 'styled-components';

import { colors, medias } from 'assets/styled/tokens';
import { Button } from 'components/Button';

export const StyledMenuMobile = styled.div`
  display: none;
  max-height: 48px;
  height: 100%;
  width: 100%;
  background: ${colors.white};
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1);
  padding: 8px 16px;
  position: sticky;
  top: 0;
  z-index: 99;
  gap: 10px;

  @media screen and (max-width: ${medias.desktopSm}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media screen and (max-width: ${medias.tablet}) {
    height: 65px;
    max-height: 65px;
  }
`;

export const StyledLogo = styled.img`
  height: auto;
  max-height: 20px;
  width: auto;
  @media screen and (max-width: ${medias.tablet}) {
    display: none;
  }
`;

export const StyledLogoMobile = styled.img`
  display: none;
  @media screen and (max-width: ${medias.tablet}) {
    width: auto;
    height: 25px;
    display: block;
  }
`;
export const StyledSymbolMobile = styled.img`
  display: none;

  @media screen and (max-width: ${medias.tablet}) {
    height: 25px;
    width: auto;
    display: block;
  }
`;

export const MobileLogoContainer = styled.div`
  display: none;

  @media screen and (max-width: ${medias.tablet}) {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 10px;
  }
`;

export const StyledMenuButton = styled(Button)`
  @media screen and (max-width: ${medias.tablet}) {
    height: 32px;
    width: 81px;
    font-size: 14px;
  }
`;

export const StyledFilterButton = styled(Button)`
  @media screen and (max-width: ${medias.tablet}) {
    display: none;
  }
`;

export const StyledHamburguer = styled.img`
  height: 16px;
  width: 16px;
  margin-right: 7px;
  cursor: pointer;
  @media screen and (max-width: ${medias.tablet}) {
    opacity: 100;
  }
`;

export const StyledBackgroundEffect = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(34, 34, 34, 0.2);
  z-index: 99;
  cursor: pointer;
  display: ${props => !props.isActive && 'none'};

  @media screen and (min-width: ${medias.desktopSm}) {
    display: none;
  }
`;
